import { render, staticRenderFns } from "./CustomerGold.vue?vue&type=template&id=6539179b"
import script from "./CustomerGold.vue?vue&type=script&lang=js"
export * from "./CustomerGold.vue?vue&type=script&lang=js"
import style0 from "./CustomerGold.vue?vue&type=style&index=0&id=6539179b&prod&lang=scss&module=true"
import style1 from "@/assets/scss/modules/element-ui.module.scss?vue&type=style&index=1&prod&lang=scss&module=elementUiStyles&external"
import style2 from "@/assets/scss/modules/utilities.module.scss?vue&type=style&index=2&prod&lang=scss&module=utilStyles&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)
this["elementUiStyles"] = (style1.locals || style1)
this["utilStyles"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports